import { render } from "./CaptionEditor.vue?vue&type=template&id=34c82458&scoped=true"
import script from "./CaptionEditor.vue?vue&type=script&lang=js"
export * from "./CaptionEditor.vue?vue&type=script&lang=js"

import "./CaptionEditor.vue?vue&type=style&index=0&id=34c82458&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34c82458"

export default script